import ExpoManagedAppConfigModule from './ExpoManagedAppConfigModule'

/**
 * Value pushed by an MDM profile (Managed App Configuration).
 * Native only — the web/android implementation always returns `null`.
 */
export const getManagedValue = (key: string) =>
  ExpoManagedAppConfigModule.getValue(key) || undefined
